module.exports = __webpack_public_path__ + "static/media/20ECE29.e1c8625d.jpg";